import type { DetailType } from 'components/DetailsViewCardHeader/types';

export const TEST_ID = 'detailsViewEntityLink';

export const ENTITY_TYPE_LABELS: Record<DetailType, string> = {
    application: 'APPLICATION',
    battery: 'BATTERY',
    boundary: 'BOUNDARY',
    city: 'CITY',
    client: 'CLIENT',
    contactName: 'CONTACT NAME',
    controllerSerialNumber: 'CNTLR. S/N',
    drone: 'DRONE',
    droneSerialNumber: 'DRONE S/N',
    email: 'EMAIL',
    estimatedAcres: 'EST. ACRES',
    faaRegistrationNumber: 'FAA REG #',
    farm: 'FARM',
    field: 'FIELD',
    flightControllerFirmwareVersion: 'FIRMWARE',
    flightHours: 'FLIGHT HRS',
    numberOfFlights: 'FLIGHTS',
    phone: 'PHONE',
    pilot: 'PILOT',
    primaryBoundary: 'PRIMARY BOUNDARY',
    role: 'ROLE',
    scheduledPilot: 'SCHEDULED PILOT',
    serialNumber: 'BATT S/N',
    state: 'STATE',
    status: 'STATUS',
    totalAcres: 'T. ACRES',
    totalAreaApplied: 'AREA APPLIED',
    totalVolumeApplied: 'VOLUME APPLIED',
    user: 'USER',
    warrantyEndDate: 'WTY. END',
    warrantyRemaining: 'WTY. RMNG',
    warrantyStartDate: 'WTY. START',
    zip: 'ZIP'
};
